import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import useStyles from './styles';

const Confirm = function ({
    isOpen,
    okButtonDisabled,
    handleClose,
    children,
    okText,
    cancelText,
    title,
    message,
    subMessage,
    ...props
}) {

    const classes = useStyles();

    function onClose(option = false) {
        handleClose && handleClose(option);
    }

    return (
        <Dialog
            open={isOpen}
            onClose={() => onClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            {...props}
            classes={{
                root: classes.root,
                paper: classes.dialogWrapper
            }}
        >
            {title && <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>}
            <DialogContent classes={{ root: classes.dialogContent }}>
                {message &&
                    <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{ __html: message }} />
                }
                {children}
            </DialogContent>
            {subMessage}
            <DialogActions className={classes.actionsContent}>
                {
                    cancelText &&
                    <Button
                        variant="contained"
                        size="large"
                        data-cy="cancel-btn"
                        id="cancel-btn"
                        onClick={() => onClose(false)}
                        classes={{ root: classes.cancelButton }}
                        autoFocus>
                        {cancelText ? cancelText : 'Não'}
                    </Button>
                }
                <Button
                    color="primary"
                    variant="contained"
                    autoFocus
                    data-cy="ok-button"
                    id="ok-button"
                    size="large"
                    disabled={okButtonDisabled}
                    classes={{ root: classes.actionButton }}
                    onClick={() => {
                        onClose(true);
                    }}>
                    {okText ? okText : 'OK'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

Confirm.defaultProps = {
    okButtonDisabled: false,
}

Confirm.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    okText: PropTypes.string,
    okButtonDisabled: PropTypes.bool,
    cancelText: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    subMessage: PropTypes.string,
};

export default Confirm;